import {useParams} from 'react-router-dom';
import {useSnackbar} from "../../../context/SnackbarContext/SnackbarContext";
import React, {useEffect, useState} from "react";
import {getPatientService} from "../../../services/patientService";

const usePatientDetails = () => {

    const {id} = useParams();

    const { showSnackbar } = useSnackbar();

    const [isLoading, setIsLoading] = useState(true);

    const [patient, setPatient] = useState(null);

    useEffect(() => {
        const init = async () => {
            setIsLoading(true);
            await loadPatient();
            setIsLoading(false);
        };

        init();
    }, []);

    const loadPatient = async () => {

        try {

            const response = await getPatientService(id);

            setPatient(response.data.data);

        } catch (error) {

            showSnackbar('Pacientes', 'Ocurrió un error cargando el paciente', 'cancel', 'warning');
        }

    };

    return {
        id,
        isLoading,
        patient,
    };
};

export default usePatientDetails;
